import { jsx as _jsx } from "react/jsx-runtime";
import { Toaster, toast as sonnerToast } from 'sonner';
import { cn } from '../lib/cn.js';
export const ToastProvider = ({ className, toastOptions, ...props }) => (_jsx(Toaster, { className: cn(className), toastOptions: {
        ...toastOptions,
        classNames: {
            toast: 'group rounded-[var(--radius-3)] border border-[var(--color-border-default)] bg-[var(--color-surface-raised)] text-[var(--color-text-primary)] shadow-lg',
            description: 'text-[var(--color-text-muted)]',
            actionButton: 'bg-[var(--color-brand-bg)] text-[var(--color-brand-fg)] rounded-[var(--radius-2)]',
            cancelButton: 'bg-[var(--color-surface-sunken)] text-[var(--color-text-primary)] rounded-[var(--radius-2)]',
            success: 'bg-[var(--color-state-success-bg)] text-[var(--color-state-success-fg)] border-[var(--color-state-success-fg)]',
            error: 'bg-[var(--color-state-danger-bg)] text-[var(--color-state-danger-fg)] border-[var(--color-state-danger-fg)]',
            warning: 'bg-[var(--color-state-warning-bg)] text-[var(--color-state-warning-fg)] border-[var(--color-state-warning-fg)]',
            info: 'bg-[var(--color-state-info-bg)] text-[var(--color-state-info-fg)] border-[var(--color-state-info-fg)]',
            ...toastOptions?.classNames,
        },
    }, ...props }));
ToastProvider.displayName = 'ToastProvider';
export const toast = sonnerToast;
//# sourceMappingURL=toast.js.map